import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';
import {ProviderOverallResult} from '../../types/overall-results.types';
import {ProviderCardComponent} from './provider-card/provider-card.component';
import {NoDataComponent} from '../../../../../../../../shared/components/no-data/no-data.component';

@Component({
  selector: 'app-executive-summary',
  imports: [TranslocoPipe, ProviderCardComponent, NoDataComponent],
  templateUrl: './executive-summary.component.html',
  styleUrl: './executive-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExecutiveSummaryComponent {
  readonly providerResults = input.required<ProviderOverallResult[]>();
}
